// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bd6daf57","239":"83933ce4","453":"b0baf046","667":"3ba3c8c8"}[chunkId] + ".chunk.js";
};